import { Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { cloneDeep } from 'lodash';
function RenderTooltip({ element }: { element?: string }) {

    const [title, setTitle] = useState('')
    const spanRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if(title){
            console.log({spanRef});
            
        }
        // Access the title attribute once the component is mounted
        if (spanRef.current && element) {
            let span = spanRef.current.querySelector('span')
            if (span) {

                setTitle(span.getAttribute('title') ?? "");
            }
        }
    }, [element]);


    const replacedTitle = () => {
        let temp = cloneDeep(element)
        return temp?.replace(/title=['"][^'"]*['"]\s*/g, "") ?? "";

    }

    if (!element) return <span >-</span>




    return (
        <>
            <div
                dangerouslySetInnerHTML={{ __html: element }}
                ref={spanRef}
                style={{ display: 'none' }}  // Make the element hidden
            />
            <Tooltip title={title} arrow placement='top'>
                <span style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: replacedTitle() }}></span>
            </Tooltip>
        </>
    )
}

export default RenderTooltip